/**
 * Extracts a user-facing message from an API/network error (a `useApiFetch` `error.value`, or a
 * thrown fetch error) so catch blocks can show real server text instead of a generic string.
 * Falls back to `fallback` when neither `data.statusMessage` nor `message` is present.
 */
export function getApiErrorMessage(err: unknown, fallback: string): string {
    const e = err as { data?: { statusMessage?: string }; message?: string } | undefined
    return e?.data?.statusMessage ?? e?.message ?? fallback
}
